import React from 'react';

import { useMutation } from '@tanstack/react-query';

import { useUiContext } from '../../context/UiContext';
import { useUiStore } from '../../store';

export default function ButtonWithConfirmation({
  label,
  confirmationMessage,
  onConfirm,
  confirmButtonLabel,
  cancelButtonLabel,
  successMessage,
  refetch,
}) {
  const { showDialogModal, showToast } = useUiContext();

  const setIsFetching = useUiStore((state) => state.setIsFetching);

  const { mutate, isPending } = useMutation({
    mutationFn: onConfirm,
    onMutate: () => {
      setIsFetching(true);
    },
    onSuccess: () => {
      showToast({
        text: successMessage,
        type: 'success',
      });
      setIsFetching(false);
      refetch?.();
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
      setIsFetching(false);
    },
  });

  return (
    <button
      disabled={isPending}
      type="button"
      className="btn undefined w-full bg-indigo-500 md:max-w-sm text-white font-bold py-2 px-4 rounded hover:bg-indigo-600"
      onClick={() => {
        showDialogModal({
          title: 'Confirmation',
          message: confirmationMessage,
          onConfirm: mutate,
          confirmButtonLabel,
          cancelButtonLabel,
        });
      }}
    >
      {label}
    </button>
  );
}
